module.exports = [
    {
        title: '重要通知',
        listApi: '/app/portal/cmsXinXi/pageList',
        detailApi: '/app/portal/cmsXinXi/detail',
        dateTitle: '发起时间',
        params: {
            xinXiGuanLiType: 49,
        },
        data: [],
        target: 'HtmlPage',
    },
]
